
import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import {environment} from '../../environments/environment';

export interface RegraMinimoNoites {
  id: number;
  quartoId: number;
  quartoNome: string;
  data: string;
  minimoNoites: number;
  ativo: boolean;
}

export interface RegraMinimoNoitesRequest {
  quartoId: number;
  data: string;
  minimoNoites: number;
  ativo: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class RegrasMinimoNoitesService {

  private readonly http = inject(HttpClient);

  // Ajuste o nome da propriedade conforme seu environment.
  private readonly apiUrl =
    `${environment.apiUrl}/admin/regras-minimo-noites`;

  private readonly publicUrl =
    `${environment.apiUrl}/regras-minimo-noites`;

  listar(): Observable<RegraMinimoNoites[]> {
    return this.http.get<RegraMinimoNoites[]>(this.apiUrl);
  }

  buscarPorId(id: number): Observable<RegraMinimoNoites> {
    return this.http.get<RegraMinimoNoites>(
      `${this.apiUrl}/${id}`
    );
  }

  criar(
    dados: RegraMinimoNoitesRequest
  ): Observable<RegraMinimoNoites> {
    return this.http.post<RegraMinimoNoites>(
      this.apiUrl,
      dados
    );
  }

  atualizar(
    id: number,
    dados: RegraMinimoNoitesRequest
  ): Observable<RegraMinimoNoites> {
    return this.http.put<RegraMinimoNoites>(
      `${this.apiUrl}/${id}`,
      dados
    );
  }

  alterarStatus(
    id: number,
    ativo: boolean
  ): Observable<RegraMinimoNoites> {
    return this.http.patch<RegraMinimoNoites>(
      `${this.apiUrl}/${id}/status`,
      { ativo }
    );
  }

  excluir(id: number): Observable<void> {
    return this.http.delete<void>(
      `${this.apiUrl}/${id}`
    );
  }

  listarPublicas(
    quartoId: number
  ): Observable<RegraMinimoNoites[]> {
    return this.http.get<RegraMinimoNoites[]>(
      this.publicUrl,
      { params: { quartoId: String(quartoId) } }
    );
  }
}
